import OpportunitiesSearchViewModel from 'opportunities/OpportunitiesSearchViewModel'
import * as React from 'react'
import { observer } from 'mobx-react'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'
import Workspace from 'iam/models/Workspace'
import { FrameValue } from 'react-spring'
import { useAnimationProgress } from 'contexts/AnimationProgressContext'

interface JobsViewHeadingProps {
  viewTitle: string
  allOptionText?: string
  searcher: OpportunitiesSearchViewModel
  workspaces: Workspace[]
  compactionAnimationProgress?: FrameValue<number>
}

export default observer(function JobsViewHeading({
  viewTitle,
  searcher,
  allOptionText,
  workspaces,
  compactionAnimationProgress,
}: JobsViewHeadingProps) {
  compactionAnimationProgress = useAnimationProgress(
    compactionAnimationProgress,
  )
  return (
    <WorkspaceSelectorViewHeading
      primaryText={viewTitle}
      allOptionText={allOptionText ?? null}
      workspaces={workspaces}
      compactionAnimationProgress={compactionAnimationProgress}
      onChange={searcher.selectWorkspaceForFiltering}
      value={
        searcher.workspaceFilter.type === 'AllWorkspaces'
          ? Workspace.none
          : searcher.workspaceFilter.workspace
      }
    />
  )
})
